import { FormControl, Typography } from "@mui/material";
import * as React from "react";
import { IIdColorTitle } from "../../../models/common/idColorTitle";
import { Translations } from "../../../models/translations";
import { Dropdown } from "../../framework/Dropdown/Dropdown";
import { EventEditUrgencyClassStateText } from "../EventEditUrgencyClassStateText/EventEditUrgencyClassStateText";

export interface IEventEditUrgencyClassFieldProp {
    urgencyClasses: IIdColorTitle[];
    disabled?: boolean;
    urgencyClassId: string;
    onChange: (urgencyClassId) => void;
}

export class EventEditUrgencyClassField extends React.Component<IEventEditUrgencyClassFieldProp, {}> {
    render() {
        const props = this.props;
        const urgencyClass = props.urgencyClasses.find(i => i.id === props.urgencyClassId);
        return (
            <FormControl fullWidth>
                <Typography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        marginBottom: ".5rem"
                    }}
                >
                    {Translations.EventUrgencyClass}
                </Typography>
                {!props.disabled &&
                    <Dropdown
                        selectedTitle={<EventEditUrgencyClassStateText urgencyClass={urgencyClass} />}
                        selectMode={true}
                        actions={props.urgencyClasses.map((uc) => {
                            return {
                                title: <EventEditUrgencyClassStateText urgencyClass={uc} wide />,
                                textTitle: uc.title,
                                selected: uc.id === props.urgencyClassId,
                                onClick: () => props.onChange(uc.id)
                            };
                        })}
                    />
                }
                {!!props.disabled &&
                    <div className="form-control noBorder"><EventEditUrgencyClassStateText urgencyClass={urgencyClass} wide={true}/></div>
                }
            </FormControl>
        );
    }
}